import { useEffect, useContext } from "react";
import { AppContext, DispatchContext } from '../../AppContext';
import { config } from '../../helpers/constants';
import * as actions from "../../actions/actions";

export default function ResetPlagiarismCheckComponent(props) {

    const state = useContext(AppContext);
    const dispatch = useContext(DispatchContext);
    useEffect(() => {
        if(state.ui.pageName !== window.location.pathname ){
            dispatch(actions.navigate_to(window.location.pathname))
            dispatch(actions.setUI({ plagCheckMenuExpanded: true }));
        }   
    }, []);
    window.location.href = config.backendUrl + 'reset-plagiarism-check';
    return null;
}